import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  // Décode le token (JWT ou token local base64)
  decodeToken(token: string): any {
    try {
      // Vérifier si c'est un JWT (3 parties séparées par des points)
      if (token.includes('.')) {
        // Séparation du token en ses 3 parties
        const [header, payload, signature] = token.split('.');

        // Décode la partie payload (base64)
        const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));

        return JSON.parse(decodedPayload);
      } else {
        // Token local encodé en base64
        const decodedToken = atob(token);
        return JSON.parse(decodedToken);
      }
    } catch (error) {
      console.error('Erreur de décodage du token', error);
      return null;
    }
  }

  // Vérifie si le token est expiré
  isTokenExpired(token: string): boolean {
    try {
      const decoded = this.decodeToken(token);

      if (!decoded) {
        return true;
      }

      // Pour les tokens JWT (utilisent 'exp' en secondes)
      if (decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp < currentTime;
      }

      // Pour les tokens locaux (utilisent 'expiresAt' en millisecondes)
      if (decoded.expiresAt) {
        return decoded.expiresAt < Date.now();
      }

      // Si aucune expiration n'est définie, considérer comme expiré
      return true;
    } catch (error) {
      return true;
    }
  }

  // Récupère les informations utilisateur du token
  getUserInfo(token: string): any {
    return this.decodeToken(token);
  }
}
